import{isLength as t}from"../../predicate/isLength.js";function i(n){return n!=null&&typeof n!="function"&&t(n.length)}export{i as isArrayLike};
